import React, {useState} from 'react';

import {createProjectStepsIndex} from '../../../../util/uiconstants';
import {labels} from '../../../../util/utils';

import {IconoirEditPencil} from '@ey-xd/motif-icon';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import OutputText from '@ey/canvascoreservices/OutputText';

import ContentSwitcher from '../../../CoreWrappers/ContentSwitcher';
import Badge from '../../../CoreWrappers/Badge';
import Step4OrgChart from '../Step4OrgChart';
import ListView from './ListView';
import StyledTeamsComponents from './StyledTeamsComponents';
import StyledTabMenu from './TabMenu/StyledTabMenu';
import StyledToolbar from './StyledToolbar';
import StyledTeams from './StyledTeams';

const TeamsComponents = (props) => {
	const cardView = {
		id: 'cardView',
		label: labels.cardView
	};
	const listView = {
		id: 'listView',
		label: labels.listView
	};

	const [viewType, setViewType] = useState('cardView');
	const fetchedTeams = props.nodes !== null;
	const hasTeams = fetchedTeams && props.nodes.length > 0;

	const renderSwitcher = () => {
		const props = {
			options: [cardView, listView],
			value: [cardView, listView].find(({id}) => id === viewType),
			onChange: ({id}) => setViewType(id)
		};

		return <ContentSwitcher {...props} />;
	};

	const renderToolBar = () => {
		return (
			<StyledToolbar>
				<StyledTabMenu className="custom-tab-menu">{renderSwitcher()}</StyledTabMenu>
			</StyledToolbar>
		);
	};

	const viewProps = {
		components: props.nodes,
		handleEditIconClick: props.handleEditIconClick,
		project: props.project,
		clientEngagements: props.clientEngagements,
		projectOwners: props.projectOwners
	};

	const renderBalkan = () => {
		return (
			<>
				<section className="chart-heading">
					<div class="left-section">
						<OutputText body2>{labels.organizationalChartHeading}</OutputText> <Badge value={props.nodes.length} />
					</div>
					<MotifIcon
						src={IconoirEditPencil}
						title={labels.edit}
						size="20"
						onClick={() => props.handleEditIconClick(createProjectStepsIndex.createOrgChart)}
					/>
				</section>
				<Step4OrgChart nodes={props.nodes} />
			</>
		);
	};

	const renderListView = () => <ListView {...viewProps} />;

	return (
		<StyledTeamsComponents>
			{hasTeams && (
				<>
					{renderToolBar()}
					<StyledTeams>
						{viewType === 'cardView' && renderBalkan()}
						{viewType === 'listView' && renderListView()}
					</StyledTeams>
				</>
			)}
		</StyledTeamsComponents>
	);
};

export default TeamsComponents;
